

(function() {
  'use strict';


  const megaMenus = document.querySelectorAll('.mega-menu');
  if (!megaMenus.length) return;

  let closeTimer;

  megaMenus.forEach(menu => {
 
    menu.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      menu.setAttribute('open', '');
    });


    menu.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        menu.removeAttribute('open');
      }, 150); 
    });
  });

})();